var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlexi = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 300 323",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M300 123V323H0V123H300ZM188.5 111H0V98H188.5V111ZM253.5 91H0V78H253.5V91ZM292.5 71H0V58H292.5V71ZM252 50H0V32H252V50ZM54 24H0V12H54V24ZM300 1H0V0H300V1Z",
  fill: "#DFDFDF"
})));
export default SvgFlexi;